import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipButtonComponent } from './tooltip-button.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PreloadSpinnerModule } from '../preload-spinner/preload-spinner.module';

@NgModule({
  declarations: [
    TooltipButtonComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    PreloadSpinnerModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    TooltipButtonComponent,
  ]
})
export class TooltipButtonModule { }
